#import "../fragments/peep-business-card-info-fragment.graphql"

query GetPeepBusinessCardInfo($entityId: ID!) {
    peep(id: $entityId) {
        ...PeepBusinessCardInfoFragment
    }
}
